import EvaluationObj from "./EvaluationObj";

export default class EvaluationObjList {
  constructor(name, initialValue=[], namespace, isEditor = false) {
    this.namespace = namespace;
    this.name = name;
    this.isEditor = isEditor;
    this.objList = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.objList;
  }

  setObjList(fobjList) {
    this.objList = fobjList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.objList.length) {
      return;
    }
    this.objList.splice(index, 1);
  }

  addValueObj(obj) {
    // console.log(obj);
    const evaluationObj = new EvaluationObj(this.name, obj, this.namespace, this.isEditor);
    this.objList.push(evaluationObj);
    // console.log(this.objList);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.addValueObj(value);
      }
    } else {
      this.addValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    // console.log(this.objList);
    const expandedList=[];
    for (let index=0; index<this.objList.length; index++) {
      const item=this.objList[index];
      if (!item.isEmpty()) {
        expandedList.push(item.getExpandedFormatValue());
      }
    }
    return expandedList;
  }

  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.objList.length; index++) {
      const listItem = this.objList[index];
      condition = condition && listItem.isEmpty();
    }
    return condition;
  }
}
